import React from 'react'
import { Outlet } from 'react-router-dom'

const StudentSupport = () => {
  return (
    <div><Outlet /></div>
    
  )
}

export default StudentSupport